/**
 * 导入工具类
 */
import { bridgeCallHandler } from '../../core';
import { printNativeMethodFallback } from '../../internal';
import { isInApp } from '../../utils';

/**
 * 设置原生存储数据
 * @param key
 * @param data
 */
export const setNativeStorage = (key: string, data: any): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    printNativeMethodFallback('setNativeStorage', 'saveDataToNative');
    return;
  }

  const params = {
    key: key,
    value: JSON.stringify(data),
  };
  bridgeCallHandler('saveDataToNative', JSON.stringify(params), null);
};

/**
 * 获取原生存储数据
 * @param key
 * @param callback
 */
export const getNativeStorage = (key: string, callback: (data: any) => void): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    printNativeMethodFallback('getNativeStorage', 'getDataByNative');
    return;
  }

  bridgeCallHandler('getDataByNative', key, callback);
};
